import { AiFillCloseCircle } from "react-icons/ai";
import SelectBox from "../../../utils/components/SelectBox";

const MetadataDetailEdit = ({ formHeaders, setFormHeaders }) => {
  const handleAdd = (index, selectedDetail) => {
    const newHeaders = [...formHeaders];
    const newOptions = newHeaders[index].details.map((detail) => {
      if (selectedDetail.value === detail.id) {
        return { ...detail, isSelected: true };
      }
      return { ...detail };
    });

    newHeaders[index].details = newOptions;

    setFormHeaders(newHeaders);
  };

  const handleRemove = (metadataIndex, index) => {
    const newHeaders = [...formHeaders];

    newHeaders[metadataIndex].details[index].isSelected = false;

    setFormHeaders(newHeaders);
  };

  return (
    <div className="container bg-white px-5 py-4">
      <div className="row">
        {formHeaders.map((metadata, i) => (
          <div
            className="col-12 d-flex flex-column my-4"
            key={metadata.metadata_set_id}
          >
            <p className="text-uppercase fs-5 fw-bold">
              {metadata.metadata_set_name}
            </p>
            <div className="col-12 col-md-5">
              <SelectBox
                options={metadata.details
                  .filter((detail) => !detail.isSelected)
                  .map((detail) => ({
                    value: detail.value,
                    label: detail.label,
                  }))}
                onChange={(detail) => handleAdd(i, detail)}
                disabled={metadata.details.some(
                  (detail) => !metadata.multi_select && detail.isSelected
                )}
              />
            </div>
            <div className="d-flex flex-wrap align-items-center mt-2">
              {metadata.details
                .filter((detail) => detail.isSelected)
                .map((detail) => (
                  <div
                    className="d-flex align-items-center text-white bg-dark me-4 my-2 px-2 py-1 rounded"
                    key={detail.value}
                  >
                    <p className="mb-0">{detail.label}</p>
                    <AiFillCloseCircle
                      className="fs-4 ms-3 text-white cursor--pointer"
                      onClick={() => {
                        handleRemove(i, metadata.details.indexOf(detail));
                      }}
                    />
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default MetadataDetailEdit;
